import { ExpandMenuProps } from 'types/ExpandMenu.type'
import styles from './styles.module.css'

export default function ExpandMenuButton ({ onClickEvent }: ExpandMenuProps) {
  return (
    <button className={styles.button} onClick={onClickEvent}>
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.960449" y="0.493652" width="20.2566" height="2.67725" rx="1.33862" fill="#7D34D0" />
        <rect x="0.960449" y="6.77588" width="20.2566" height="2.67725" rx="1.33862" fill="#7D34D0" />
        <rect x="0.960449" y="13.0581" width="20.2566" height="2.67725" rx="1.33862" fill="#7D34D0" />
      </svg>
    </button>
  )
}
